<template>
  <div>
    <v-dialog v-model="isAdding" title="Add a new crypto rate" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Add a new Traditional Currency</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <create-tradtional-form @created="currencyCreated" />
        </v-container>
      </v-card>
    </v-dialog>
    <data-table
      :headers="headers"
      url="/api/v1/traditionalCurrencies"
      title="Traditional Currencies"
      item-key="id"
      ref="table"
      searchable
    >
      <v-btn slot="action.icons" color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Currency
      </v-btn>

      <template slot="item.created_at" slot-scope="{ item }">
        {{ item.created_at | date }}
      </template>
    </data-table>
  </div>
</template>

<script>
import CreateTradtionalForm from "./traditionalForm";
export default {
  components: { CreateTradtionalForm },
  data() {
    return {
      isAdding: false,
      headers: this.pairTableLabelWithValue({
        Name: "name",
        Country: "country",
        "Short Name": "short_name",
        Symbol: "symbol",
        "Created On": "created_at",
      }),
    };
  },
  methods: {
    currencyCreated() {
      this.isAdding = false;
      this.$refs.table.fetchData();
      window.Notify.success("Crypto currency was created successfully");
    },
  },
};
</script>
